
export default function About() {
  const stats = [
    { number: '150+', label: 'Projects Completed' },
    { number: '25+', label: 'Years Experience' },
    { number: '98%', label: 'Client Satisfaction' },
    { number: '50+', label: 'Expert Team Members' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
              Engineering Excellence in Every Project
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              With decades of combined expertise in construction project management and HVAC systems, we specialize in delivering custom solutions for the most challenging facility requirements.
            </p>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-800 mb-2">Precision & Reliability</h3>
                  <p className="text-gray-600">Every project executed with meticulous attention to detail and unwavering commitment to quality standards.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-leaf-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-800 mb-2">Sustainable Innovation</h3>
                  <p className="text-gray-600">Implementing cutting-edge technologies and sustainable practices for environmentally responsible solutions.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-settings-3-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-800 mb-2">Technical Expertise</h3>
                  <p className="text-gray-600">Deep industry knowledge and advanced technical capabilities to handle the most complex facility challenges.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/a7faefc3db31c23bec846fd7ea0f4168.jpg"
              alt="Professional construction team"
              className="rounded-xl shadow-2xl object-cover w-full h-96 lg:h-[500px] object-top"
            />
            <div className="absolute -bottom-8 -left-8 bg-slate-800 rounded-xl p-6 shadow-xl">
              <div className="grid grid-cols-2 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-2xl font-bold text-orange-500">{stat.number}</div>
                    <div className="text-sm text-gray-300">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
